export const linguagens = [
    {
        Imagem: './../../assets/img/sobre/linguagens/angular.png'
    }, 
    {
        Imagem: './../../assets/img/sobre/linguagens/sql.png'
    },
    {
        Imagem: './../../assets/img/sobre/linguagens/cSharp.png'
    },
    {
        Imagem: './../../assets/img/sobre/linguagens/css.png'
    },
    {
        Imagem: './../../assets/img/sobre/linguagens/dotnet2.png'
    },
    {
        Imagem: './../../assets/img/sobre/linguagens/html.png'
    },
    {
        Imagem: './../../assets/img/sobre/linguagens/javascript.png'
    },
    {
        Imagem: './../../assets/img/sobre/linguagens/oracle.png'
    },
    {
        Imagem: './../../assets/img/sobre/linguagens/vstudio.png'
    },
    {
        Imagem: './../../assets/img/sobre/linguagens/flutter.png'
    },
    {
        Imagem: './../../assets/img/sobre/linguagens/android.png'
    },
    {
        Imagem: './../../assets/img/sobre/linguagens/windows.png'
    },
]